var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-jumbotron',[_c('h6',[_c('strong',[_vm._v("Oh oh...")]),_vm._v(" er zijn geen "),_c('code',[_vm._v(_vm._s(_vm.name))]),_vm._v(" om geladen te worden...")]),_c('hr'),_c('p',[_vm._v(" Probeer de zoektermen aan te passen! ")])])}
var staticRenderFns = []

export { render, staticRenderFns }